module.exports = __webpack_public_path__ + "img/logo2.3cd001b3.png";